var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconCrown = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("path", { d: "M8.2,25.7h13.2c0.2-1.7,0.5-3.4,1-5c0.6-2.3,2-4.7,3.1-6.8l-4.3,2.3l-2.2,1.2\n\t\tc-0.8-0.9-1.4-1.9-1.8-3c-1-2.2-2.4-6-2.4-6s-1.3,3.6-2.3,5.9c-0.5,1.1-1.1,2.2-1.9,3.1L8.1,16l-3.5-1.9c1.1,2.1,2,4.3,2.6,6.5\n\t\tC7.7,22.3,8,24,8.2,25.7z" }),
                React.createElement("circle", { cx: "4", cy: "12.1", r: "2" }),
                React.createElement("circle", { cx: "14.7", cy: "6.3", r: "2" }),
                React.createElement("circle", { cx: "26", cy: "11.8", r: "2" })))));
});
export default IconCrown;
//# sourceMappingURL=IconCrown.js.map